import apiResetPassword from '@/api/reset-password'

const state = {
  isSubmitting: false,
  data: null,
  user: null,
  state: null,
  validationErrors: null,
}

export const actionTypes = {
  resetPassword: '[reset password] reset password',
  sendSms: '[reset password] send sms',
  checkSms: '[reset password] check sms',
  changePassword: '[reset password] change password'
}

export const mutationTypes = {
  resetPasswordStart: '[reset password] send resetPassword Start',
  resetPasswordSuccess: '[reset password] send resetPassword Success',
  resetPasswordFailure: '[reset password] send resetPassword Failure',

  sendSmsStart: '[reset password] send sms Start',
  sendSmsSuccess: '[reset password] send sms Success',
  sendSmsFailure: '[reset password] send sms Failure',

  checkSmsStart: '[reset password] check sms Start',
  checkSmsSuccess: '[reset password] check sms Success',
  checkSmsFailure: '[reset password] check sms Failure',

  changePasswordStart: '[reset password] change password Start',
  changePasswordSuccess: '[reset password] change password Success',
  changePasswordFailure: '[reset password] change password Failure',

  clearErrors: '[reset password] clear errors',
}
const mutations = {
  [mutationTypes.resetPasswordStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },
  [mutationTypes.resetPasswordSuccess](state, payload) {
    state.isLoading = false
    state.state = payload
  },
  [mutationTypes.resetPasswordFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.sendSmsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },
  [mutationTypes.sendSmsSuccess](state, payload) {
    state.isLoading = false
    state.data = payload
  },
  [mutationTypes.sendSmsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.checkSmsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },
  [mutationTypes.checkSmsSuccess](state, payload) {
    state.isLoading = false
    state.data = payload
  },
  [mutationTypes.checkSmsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.changePasswordStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },
  [mutationTypes.changePasswordSuccess](state, payload) {
    state.isLoading = false
    state.data = payload
  },
  [mutationTypes.changePasswordFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.clearErrors](state) {
    state.validationErrors = null
  },
}

const actions = {
  [actionTypes.resetPassword](context, user) {
    return new Promise((resolve) => {
      apiResetPassword
        .resetPassword(user)
        .then((response) => {
          const {state} = response.data
          context.commit(mutationTypes.resetPasswordSuccess, state)
          resolve(state)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.resetPasswordFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionTypes.sendSms](context, data) {
    context.commit(mutationTypes.sendSmsStart)
    return new Promise((resolve) => {
      apiResetPassword
        .sendSmsCode(data)
        .then((response) => {
          context.commit(mutationTypes.sendSmsSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.sendSmsFailure,
            result.response.data.message
          )
        })
    })
  },

  [actionTypes.checkSms](context, data) {
    context.commit(mutationTypes.checkSmsStart)
    return new Promise((resolve, reject) => {
      apiResetPassword
        .checkSmsCode(data)
        .then((response) => {
          context.commit(mutationTypes.checkSmsSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.checkSmsFailure,
            result.response.data.message
          )
          reject(result.response.data.message)
        })
    })
  },

  [actionTypes.changePassword](context, stateAndPassword) {
    context.commit(mutationTypes.changePasswordStart)
    return new Promise((resolve, reject) => {
      apiResetPassword
        .changePassword(stateAndPassword)
        .then((response) => {
          context.commit(mutationTypes.changePasswordSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.changePasswordFailure,
            result.response.data.message
          )
          reject(result.response.data.message)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
